module.exports = __webpack_public_path__ + "img/fondo-verde.a08193de.jpg";